import React, { useCallback, useEffect, useState } from 'react';
import handlePromise from 'utils/Promise';
import DocsRequestService from 'services/api/DocsRequest';
import { useSelector } from 'react-redux';
import { selectUserAccount } from 'store/User';
import { DocRequestEntity, DocRequestGrouped } from 'types/DocRequest';
import { DocRequestTemplateCategoryType } from 'types/DocRequestTemplate';
import _ from 'lodash';
import DocsView from './components/View';

function DocsScreen() {
  const userAccountId = useSelector( selectUserAccount );

  const [dataLoading, setDataLoading] = useState<boolean>( false );
  const [data, setData] = useState<DocRequestGrouped>( {
    [DocRequestTemplateCategoryType.physical]: [],
    [DocRequestTemplateCategoryType.fiscal]: [],
    [DocRequestTemplateCategoryType.investments]: [],
    [DocRequestTemplateCategoryType.titular]: [],
  } );

  const fetchData = useCallback( async () => {
    if ( userAccountId ) {
      setDataLoading( true );
      const [, response, responseData] = await handlePromise(
        DocsRequestService.getDocRequests( userAccountId ),
      );
      setDataLoading( false );

      if ( response.ok ) {
        const groupedData = _.groupBy( responseData.data, 'categoria' );
        setData( groupedData );
      }
    }
  }, [userAccountId] );

  const updateItem = useCallback( ( newItem: DocRequestEntity ) => {
    if ( newItem && newItem.categoria ) {
      const category = newItem.categoria as DocRequestTemplateCategoryType;

      setData( ( prev ) => {
        const i = prev[category]?.findIndex( ( item ) => item.id === newItem.id );
        if ( i === -1 ) return prev;
        const newData = JSON.parse( JSON.stringify( prev ) );
        newData[category][i as number] = newItem;
        return newData;
      } );
    }
  }, [] );

  useEffect( () => {
    fetchData();
  }, [userAccountId] );

  return (
    <DocsView
      data={data}
      loading={dataLoading}
      setItem={updateItem}
    />
  );
}

export default DocsScreen;
